import { render, staticRenderFns } from "./BeneficiaryAccountCheck.vue?vue&type=template&id=619c9c32&scoped=true"
import script from "./BeneficiaryAccountCheck.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountCheck.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryAccountCheck.vue?vue&type=style&index=0&id=619c9c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c9c32",
  null
  
)

export default component.exports